// extracted by mini-css-extract-plugin
module.exports = {"hoverCard":"cursorCardWrapper_hoverCard__yi16h"};